@switch (bannerStyle) {
  @case ('Full') {
    <div
      class="bg-blue-50 overflow-hidden rounded-md relative flex flex-col gap-4 lg:gap-2 md:flex-row items-center justify-between p-4 lg:px-12 lg:py-0"
    >
      <div class="text-center lg:text-left">
        <span class="block text-white text-3xl lg:text-[64px] font-bold leading-[32px] lg:leading-[64px]">It's official.</span>
        <span class="block text-awards-primary text-xl lg:text-[32px]">You're An Award Winner!</span>
      </div>

      <img [src]="'/assets/images/promotion-banner/awards/awards-banner-2025.png' | staticAsset" alt="" />

      <div>
        <a
          [routerLink]="'/awards/checkout'"
          data-id="promo-award-banner-cta"
          class="!text-blue-100 whitespace-nowrap bg-awards-primary text-[22px] rounded-sm px-8 py-3 hover:!no-underline hover:!text-blue-50 transition-colors"
        >
          Order your trophy
        </a>
      </div>
    </div>
  }
}
